/**
 * Pre-compiled localized messages for Dialog component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import dialogMessages_en from "./intl/en";
import dialogMessages_de from "./intl/de";
import dialogMessages_es from "./intl/es";
import dialogMessages_fr from "./intl/fr-FR";
import dialogMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const dialogMessagesStrings: LocalizedStrings<string, LocalizedString> =
  {
    en: normalizeMessages(dialogMessages_en),
    de: normalizeMessages(dialogMessages_de),
    es: normalizeMessages(dialogMessages_es),
    "fr-FR": normalizeMessages(dialogMessages_fr),
    "pt-BR": normalizeMessages(dialogMessages_pt),
  } as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Dialog component
 */
export type DialogMessageKey = "closeTrigger";
